import type { FaireProductEntity } from "../../entity_types/product";

export const p_vtqb2umztw: FaireProductEntity = {
  token: "p_vtqb2umztw",
  type: "product",
  name: "Wiggle Stripe Knit Grid Tee - Calathea",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/b6062209c48e03b1b8be596266343da770357a239477af85039c9a286d394244.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6bbd281bc027f69e461c872f0d7f878799358a062793d3f8bb2fec6904e1d0f7.jpeg",
    "https://cdn.faire.com/fastly/f3996750920c605551606277d763dfd0c72a85ca541f1393877fc822e91a603d.jpeg",
    "https://cdn.faire.com/fastly/43b33bbbcf3f9535fd1794533322a9638baddc70de72c760bd334cc389416f86.jpeg",
    "https://cdn.faire.com/fastly/6486697803e49f89c79b5d9cb2ecd1b0b3886f8fc15b6f8e577ed58e6ef73c1e.jpeg"
  ],
  priceDollars: 75.6,
  description: "The Wiggle Stripe Tee has a relaxed shape that follows the body with a more fluid feel, created through its alternating rib structure. The surface shifts slightly as it moves, giving the silhouette a soft, wavy line. Lightweight and breathable, it sits comfortably on the body and feels easy to wear in warmer conditions.\n\nRather than relying on bold graphics, the texture carries the design. Alternating ribs create a gentle “wiggle” effect, adding subtle dimension and movement across the surface. The result is a piece that feels understated but dynamic. Pairing naturally with jeans, skirts, or shorts for everyday wear.\n\n * 100% cotton \n * Relaxed fit with a subtle wavy texture \n * Lightweight and breathable with a soft, flexible feel \n * Ideal for warm weather \n * Designed for spring and summer wear \n * Pairs well with jeans, skirts, or shorts ",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:28.027Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
